import { WidgetsServicesReportFormMain } from '@/widgets/services-report-form';

export const PagesServicesVideoFormMain = () => <WidgetsServicesReportFormMain reportType="VIDEO" />;
